import React from "react";
import Preloader from "../helper/Preloader";
import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
  import ScrollToTop from "react-scroll-to-top";
 import FooterOne from "../components/FooterOne";
 import OrderViewAmazon from "../componentsAmazon/OrderViewAmazon";
import OrderViewAmazonCutomer from "../componentsAmazon/OrderViewAmazonCutomer";
import HeaderFooterInit from "../componentsAmazon/HeaderFooterInit";
   

const PendingOrderCustomer = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

       {/* HeaderFooterInit */}
       <HeaderFooterInit/>
      {/* Penging */}
      <OrderViewAmazonCutomer />
 
 

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default PendingOrderCustomer;
